import React from "react";
import { Pagination } from "@mui/material";
import { limit, SendPageSave } from "utils";
import { useLocation, useNavigate } from "react-router";

export const PaginationSimple = ({ count }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const info = location?.state;
  const page = info?.page;

  const handleChangePage = (val) => {
    window.scrollTo(0, 0);
    SendPageSave(navigate, val, info, location?.pathname);
  };

  return (
    <div className="simple-pagination-wrapper">
      <Pagination
        className="simple-pagination-box"
        onChange={(event, val) => handleChangePage(val)}
        page={page}
        count={count && Math.ceil(count / limit)}
        color={"primary"}
      />
    </div>
  );
};
